import React from "react";
import { Rating } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";

const StarRating = ({ rating, readOnly = true, size = "medium", onChange }) => {
  return (
    <Rating
      name="rating"
      value={rating || 0}
      precision={0.5}
      readOnly={readOnly}
      size={size}
      onChange={(event, newValue) => {
        if (onChange) onChange(newValue);
      }}
      emptyIcon={
        <StarIcon style={{ opacity: 0.55, color: "#d3d3d3" }} fontSize="inherit" />
      }
      sx={{
        "& .MuiRating-iconFilled": {
          color: "#C93312", // Red color matching the theme
        },
        "& .MuiRating-iconEmpty": {
          color: "#d3d3d3",
        },
      }}
    />
  );
};

export default StarRating;

